// Global Instructions Rule Applied!
//
// Deal Execution board state — the merged execution kanban's rows. Data flows
// service → hook → this reducer → board component (house layering).
import {
  MARK_EXECUTION_BOARD_STALE,
  SET_EXECUTION_BOARD,
  UPDATE_EXECUTION_BOARD_ROW
} from './constants.ts'
import {
  DealExecutionBoardRecord,
  DealExecutionBoardRecordFields
} from '../../data_models/deal_execution_board_model.ts'

export interface DealExecutionState {
  board: DealExecutionBoardRecord[]
  /** Set by cross-module writers (e.g. deal creation, which can auto-enroll
   *  the deal in execution server-side); the board hook refetches with its
   *  own filters and SET_EXECUTION_BOARD clears it. */
  stale: boolean
}

type DealExecutionAction =
  | { type: typeof SET_EXECUTION_BOARD; payload: { rows: DealExecutionBoardRecord[] } }
  | {
      type: typeof UPDATE_EXECUTION_BOARD_ROW
      payload: { pipelineDealsId: string; updates: Partial<DealExecutionBoardRecord> }
    }
  | { type: typeof MARK_EXECUTION_BOARD_STALE }

const dealExecutionReducer = (
  state: DealExecutionState = { board: [], stale: false },
  action: DealExecutionAction
): DealExecutionState => {
  switch (action.type) {
    case SET_EXECUTION_BOARD:
      return { ...state, board: action.payload.rows, stale: false }
    case MARK_EXECUTION_BOARD_STALE:
      return { ...state, stale: true }
    case UPDATE_EXECUTION_BOARD_ROW: {
      const idKey = DealExecutionBoardRecordFields.pipeline_deals__id
      return {
        ...state,
        board: state.board.map((row) =>
          row[idKey] === action.payload.pipelineDealsId ? { ...row, ...action.payload.updates } : row
        )
      }
    }
    default:
      return state
  }
}

export const setExecutionBoard = (rows: DealExecutionBoardRecord[]) => ({
  type: SET_EXECUTION_BOARD,
  payload: { rows }
})

export const markExecutionBoardStale = () => ({ type: MARK_EXECUTION_BOARD_STALE })

export const updateExecutionBoardRow = (
  pipelineDealsId: string,
  updates: Partial<DealExecutionBoardRecord>
) => ({
  type: UPDATE_EXECUTION_BOARD_ROW,
  payload: { pipelineDealsId, updates }
})

export default dealExecutionReducer
